module.exports = __webpack_public_path__ + "notification.6afe1741.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/notifications/notification.png
// module id = 1501
// module chunks = 0